<script>
	import Chart from 'chart.js'
	import {Line, mixins as chartMixins} from 'vue-chartjs';

	const {reactiveProp} = chartMixins
	Chart.defaults.global.elements.point.radius = 1
	Chart.defaults.global.elements.line.borderWidth = 1.5
	Chart.plugins.register({
		afterDraw: function (chart) {
			if(chart.data.datasets.length === 0 || !chart.data.datasets.some(c => c.data.some(d => d > 0))) {
				let ctx = chart.chart.ctx;
				let width = chart.chart.width;
				let height = chart.chart.height

				ctx.save();
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';
				ctx.font = "bolder 20px 'Roboto'";
				ctx.fillStyle = "rgba(31, 101, 197, 0.101960784313725)";
				ctx.fillText('No data to display', width / 2, height / 2);
				ctx.restore();
			}
		}
	});
	export default {
		extends: Line,
		name: "LineChart",
		mixins: [reactiveProp],
		props: {
			options: {
				type: Object,
				required: true,
				default: null
			}
		},
		data() {
			return {}
		},
		mounted() {
			this.$nextTick(() => {
				this.renderChart(this.chartData, this.options);
			})
		},
		watch:{
			options:{
				handler(val){
					this.renderChart(this.chartData, val);
				},
                deep:true
            }
        }
	}
</script>

<style scoped>

</style>
